const ChairishContext = window.chairisher.context;

/**
 * @returns {Object}
 */
export function getPaymentRequestWalletNames() {
    return ChairishContext.PAYMENT_REQUEST_WALLET_NAMES;
}

/**
 * @returns {string} The Braintree client token embedded in the JS context
 */
export function getBraintreeClientToken() {
    return ChairishContext.BRAINTREE_CLIENT_TOKEN;
}

/**
 * @returns {string} Token representing a saved Braintree linkage
 */
export function getBraintreePaymentMethodToken() {
    return ChairishContext.BRAINTREE_PAYMENT_METHOD_TOKEN;
}

export function removeBraintreePaymentMethodToken() {
    ChairishContext.BRAINTREE_PAYMENT_METHOD_TOKEN = '';
}

/**
 * Get the URL to hit to create a credit card
 *
 * @returns {string}
 */
export function getCreateSavedCardsUrl() {
    return ChairishContext.PAYMENT_CREATE_SAVED_CARDS_URL;
}

/**
 * @param {string} brand The brand name of the credit card to display;
 * "American Express" should be passed in as "amex"
 *
 * @returns {string}
 */
export function getCreditCardLogoUrl(brand) {
    return ChairishContext.CREDIT_CARD_BRAND_TO_LOGO_URL_MAP[brand.toLowerCase()] || '';
}

/**
 * Get the URL to hit to delete a credit card
 *
 * @returns {string}
 */
export function getDeleteSavedCardsUrl() {
    return ChairishContext.PAYMENT_DELETE_SAVED_CARDS_URL;
}

/**
 * @returns {Object}
 */
export function getPaymentProcessorCodes() {
    return ChairishContext.PAYMENT_PROCESSOR_CODES;
}

/**
 * @returns {string} The publishable Stripe API key
 */
export function getPublishableStripeApiKey() {
    return ChairishContext.STRIPE_API_PUBLISHABLE;
}

/**
 * @returns {string} The success message to display
 */
export function getSuccessMessage() {
    return ChairishContext.SUCCESS_MESSAGE;
}

/**
 * @returns {boolean} Indicates if Paypal is enabled as a payment method
 */
export function isPaypalEnabled() {
    return ChairishContext.IS_PAYPAL_ENABLED;
}
